import React, { createContext, useState, useContext, useEffect } from 'react';
import { authAPI } from './api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('auth_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      if (token) {
        try {
          const userData = await authAPI.getMe(token);
          setUser(userData);
        } catch (error) {
          console.error('Failed to get user data:', error);
          // Token is invalid, clear it
          localStorage.removeItem('auth_token');
          setToken(null);
        }
      }
      setLoading(false);
    };

    initAuth();
  }, [token]);

  const login = async (email, password) => {
    const data = await authAPI.login(email, password);
    setToken(data.access_token);
    localStorage.setItem('auth_token', data.access_token);
    const userData = await authAPI.getMe(data.access_token);
    setUser(userData);
    return data;
  };

  const signup = async (email, password) => {
    const data = await authAPI.signup(email, password);
    setToken(data.access_token);
    localStorage.setItem('auth_token', data.access_token);
    const userData = await authAPI.getMe(data.access_token);
    setUser(userData);
    return data;
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('auth_token');
    localStorage.removeItem('triggerdocs_project'); // Clear saved project
  };

  const value = {
    user,
    token,
    loading,
    login,
    signup,
    logout,
    isAuthenticated: !!user,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
